import { render, staticRenderFns } from "./ProjeTanimla.vue?vue&type=template&id=2f66737c&scoped=true&"
import script from "./ProjeTanimla.vue?vue&type=script&lang=js&"
export * from "./ProjeTanimla.vue?vue&type=script&lang=js&"
import style0 from "./ProjeTanimla.vue?vue&type=style&index=0&id=2f66737c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66737c",
  null
  
)

export default component.exports